import React from 'react';

function Price() {
  return (
    <div className="sec-box price section-padding" id="price">
      <div className="sec-head mb-80 wow fadeInUp">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <h6 className="sub-title opacity-7 mb-15">Best Pricing</h6>
            <h3>
              <span className="main-color">Flexible</span> Pricing Plan
            </h3>
          </div>
        </div>
      </div>
      <div className="row md-marg">
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".2s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Basic</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">$19</h2>
                <p className="ml-20 fz-20">/ hour</p>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Need your wireframe</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Design with Figma, Framer</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Implement with Webflow, React, WordPress, Laravel/PHP
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Support 6 months</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                  <a
                    href="#0"
                    className="butn butn-md butn-bord radius-5 text-u full-width"
                  >
                    <span>Get Started</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".4s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Popular</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">$39</h2>
                <p className="ml-20 fz-20">/ hour</p>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Need your wireframe</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Design with Figma, Framer</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Implement with Webflow, React, WordPress, Laravel/PHP
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Support 6 months</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Your project alway be priority</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                  <a
                    href="#0"
                    className="butn butn-md butn-bord radius-5 text-u full-width"
                  >
                    <span>Get Started</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div className="item full-width wow fadeIn" data-wow-delay=".6s">
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Premium</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">$59</h2>
                <p className="ml-20 fz-20">/ hour</p>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Need your wireframe</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Design with Figma, Framer</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Implement with Webflow, React, WordPress, Laravel/PHP
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Support 6 months</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                  <a
                    href="#0"
                    className="butn butn-md butn-bord radius-5 text-u full-width"
                  >
                    <span>Get Started</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Price;
